import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import FormCheckbox from './form-checkbox';
import { classNames } from '@repo/ui/src/utils/classNames';

const FormAcknowledgement = ({ item, unique, submitted, layout, preCheck }) => {
  const checkLink = item.link ? buildLinkObj(item.link) : null;
  const LinkItem = () => {
    return checkLink.href !== 'link-not-set-amp' ? (
      <a rel={getRel(checkLink)} href={checkLink.href} className="tw-underline">
        {item.link.displayName}
      </a>
    ) : null;
  };
  return (
    <div>
      <div
        className={classNames(
          'tw-relative tw-py-3 tw-mb4 tw-border tw-border-transparent',
          layout !== 'One Column' && 'tw-text-center',
        )}
        role="alert"
        aria-atomic="true"
      >
        {item.display ? (
          <FormCheckbox
            item={item}
            unique={item.unique}
            key={unique}
            submitted={submitted}
            Link={LinkItem}
            preCheck={preCheck}
          />
        ) : (
          item.title
        )}
      </div>
    </div>
  );
};

export default FormAcknowledgement;
